const MainTitle = 'Free2Move';

const routes = {
  signin: {
    path: '/access',
    title: `Auth - ${MainTitle}`
  },
  home: {
    path: '/',
    title: `Home - ${MainTitle}`
  },
  forgotpassword: {
    path: '/forgotpassword',
    title: `Forgot Password- ${MainTitle}`
  },
  personalData: {
    path: '/personal-data',
    title: `Add personal data- ${MainTitle}`
  },
  people: {
    path: '/people',
    title: `People - ${MainTitle}`
  },
  createNewPassword: {
    path: '/createNewPassword',
    title: `Create New Password - ${MainTitle}`
  },
  changePassword: {
    path: '/changePassword',
    title: `Change Password - ${MainTitle}`
  },
  updateData: {
    path: '/updateData',
    title: `Update Data - ${MainTitle}`
  },
  accountManagement: {
    path: '/account',
    title: `Account Management - ${MainTitle}`
  },
  lead: {
    path: '/lead',
    title: `Lead - ${MainTitle}`
  }
};

export default routes;
